import Axios from "axios";
import {
    SET_EDITING_INV_REQUISITION_DELIVERY_LIST,
    SET_INV_REQUISITION_DELIVERY_LIST,
    UNSET_EDITING_INV_REQUISITION_DELIVERY_LIST,
    UNSET_INV_REQUISITION_DELIVERY_LIST,
    SET_INV_PRODUCTION_REQUISITION_DELIVERY_LIST,
    UNSET_INV_PRODUCTION_REQUISITION_DELIVERY_LIST,
} from "@/store/mutation-types";
import {
    saveUpdateInvRequisitionDeliveryList,
    getInvRequisitionDeliveryList,
    getInvRequisitionDeliveryById as getInvRequisitionDeliveryByIdApi,
    saveUpdateInvProductionRequisitionDelivery,
    getInvProductionRequisitionDeliveryList,
    getInvProductionRequisitionDeliveryById,
} from "@/store/api";

const state = {
    getInvRequisitionDeliveryList: [],
    editingInvRequisitionDelivery: null,
    getInvProductionRequisitionDeliveryList: [],
};

const getters = {
    getInvRequisitionDeliveryList(state) {
        return state.getInvRequisitionDeliveryList;
    },
    getEditingRequisition: (state) => {
        return state.editingInvRequisitionDelivery;
    },
    getInvProductionRequisitionDeliveryList(state){
        return state.getInvProductionRequisitionDeliveryList;
    }
};

const mutations = {
    [SET_INV_REQUISITION_DELIVERY_LIST](state, data) {
        state.getInvRequisitionDeliveryList = data;
    },
    [UNSET_INV_REQUISITION_DELIVERY_LIST](state) {
        state.getInvRequisitionDeliveryList = [];
    },
    [SET_EDITING_INV_REQUISITION_DELIVERY_LIST](state, requisition) {
        state.editingRequisition = requisition;
    },
    [UNSET_EDITING_INV_REQUISITION_DELIVERY_LIST](state) {
        state.editingRequisition = null;
    },

    [SET_INV_PRODUCTION_REQUISITION_DELIVERY_LIST](state, data) {
        state.getInvProductionRequisitionDeliveryList = data;
    },
    [UNSET_INV_PRODUCTION_REQUISITION_DELIVERY_LIST](state) {
        state.getInvProductionRequisitionDeliveryList = [];
    },
};

const actions = {
    saveUpdateInvRequisitionDelivery({ commit }, data) {
        commit("SET_LOADING", { color: "primary" });
        return new Promise((resolve, reject) => {
        Axios.post(saveUpdateInvRequisitionDeliveryList, data)
            .then(function (response) {
                resolve(response);
            })
            .catch(function (error) {
                reject(error);
            })
            .then((always) => {
                commit("UNSET_LOADING");
            });
        });
    },

    getInvRequisitionDeliveryList({ commit }, data) {
        return new Promise((resolve, reject) => {
            Axios.post(getInvRequisitionDeliveryList, data)
                .then(function (response) {
                    commit("SET_INV_REQUISITION_DELIVERY_LIST", response.data.data);
                    resolve(response);
                })
                .catch(function (error) {
                    commit("UNSET_INV_REQUISITION_DELIVERY_LIST");
                    reject(error);
                })
                .then((always) => {});
            }
        );
    },

    getInvRequisitionDeliveryById({ commit }, id) {
        const getInvRequisitionDeliveryById = `${getInvRequisitionDeliveryByIdApi}/${id}`;
        commit("SET_LOADING", { color: "primary" });
        return new Promise((resolve, reject) => {
            Axios.post(getInvRequisitionDeliveryById)
                .then((response) => {
                    resolve(response.data.data);
                })
                .catch((error) => {
                    reject(error);
                })
                .then((always) => {
                    commit("UNSET_LOADING");
                });
            }
        );
    },


    saveUpdateInvProductionRequisitionDelivery({ commit }, data) {
        commit("SET_LOADING", { color: "primary" });
        return new Promise((resolve, reject) => {
        Axios.post(saveUpdateInvProductionRequisitionDelivery, data)
            .then(function (response) {
                resolve(response);
            })
            .catch(function (error) {
                reject(error);
            })
            .then((always) => {
                commit("UNSET_LOADING");
            });
        });
    },

    getInvProductionRequisitionDeliveryList({ commit }, data) {
        return new Promise((resolve, reject) => {
            Axios.post(getInvProductionRequisitionDeliveryList, data)
                .then(function (response) {
                    commit("SET_INV_PRODUCTION_REQUISITION_DELIVERY_LIST", response.data.data);
                    resolve(response);
                })
                .catch(function (error) {
                    commit("UNSET_INV_PRODUCTION_REQUISITION_DELIVERY_LIST");
                    reject(error);
                })
                .then((always) => {});
            }
        );
    },

    getInvProductionRequisitionDeliveryById({ commit }, id) {
        const getInvProductionRequisitionDeliveryByIdUrl = `${getInvProductionRequisitionDeliveryById}/${id}`;
        commit("SET_LOADING", { color: "primary" });
        return new Promise((resolve, reject) => {
            Axios.post(getInvProductionRequisitionDeliveryByIdUrl)
                .then((response) => {
                    resolve(response.data.data);
                })
                .catch((error) => {
                    reject(error);
                })
                .then((always) => {
                    commit("UNSET_LOADING");
                });
            }
        );
    },
};

export default {
    state,
    getters,
    actions,
    mutations,
};
